module.exports = __webpack_public_path__ + "static/img/S1.0a0d9b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/S1.png
// module id = ciWg
// module chunks = 1